import { getConfigData, getCookie, setCookie } from "@cash/shared-components";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ActionButton,
  Flex,
  Button,
  Dialog,
  Heading,
  Content,
  Image,
  TooltipTrigger,
  Tooltip,
  Provider,
  defaultTheme,
} from "@adobe/react-spectrum";
import Home from "@spectrum-icons/workflow/Home";
import LogOut from "@spectrum-icons/workflow/LogOut";
import "./index.css";
import dssLogo from "./Digital-Solutions-&-Services-logo.png";

const Header = ({
  title,
  onClick,
  showHome = true,
  secondaryTitle,
  showLogout = true,
  showLogo = false,
}) => {
  const navigate = useNavigate();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const bypassLogin = getCookie("login_type") === "BYPASS";
  const [expirationMinutes, setExpirationMinutes] = useState(null);

  useEffect(() => {
    getConfigData().then((data) =>
      setExpirationMinutes(data.SESSION_EXPIRATION_MINUTES || 30)
    );
  }, []);

  const handleLogout = () => {
    setCookie('user_email', null, expirationMinutes);
    setCookie('pas', null, expirationMinutes);
    setCookie('user_token', null, expirationMinutes);
    setCookie('login_type', null, expirationMinutes);
    localStorage.setItem("activeUser", null);
    const redirectUrl = bypassLogin ? '/login' : '/logout';
    window.location.href = redirectUrl;
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };
  const handleHomeClick = () => navigate("/home");

  return (
    <>
      <header
        className="dashboard-header"
        style={{ padding: showLogo ? 0 : "1rem" }}
      >
        <Flex
          justifyContent="space-between"
          alignItems="center"
          height="size-800"
        >
          <Flex alignItems="center" gap="size-200">
            {showLogo && (
              <Image
                UNSAFE_className="img"
                UNSAFE_style={{ width: "230px" }}
                src={dssLogo}
                alt="DSS Logo"
                height="size-800"
              />
            )}

            <ActionButton
              onPress={() => {
                showHome && handleHomeClick();
              }}
              UNSAFE_style={{
                paddingTop: "4px",
                height: "30px",
                width: "50px",
                border: "none",
                fill: "white",
              }}
            >
              {showHome && <Home UNSAFE_className="bell_icon" />}
            </ActionButton>
          </Flex>
          <span
            style={{
              alignContent: "center",
              marginLeft: showLogo ? "-280px" : 0,
              fontSize: "25px",
              // textAlign: showLogo ? "null" : "left",
            }}
          >
            {title}
          </span>

          <Flex alignItems="center" gap="size-300">
            <span
              style={{
                alignContent: "center",
                cursor: onClick ? "pointer" : null,
                textAlign: "left",
                marginRight: "20px",
              }}
              onClick={onClick}
            >
              {secondaryTitle}
            </span>
            <Provider theme={defaultTheme} colorScheme="dark">
              <TooltipTrigger offset={21}>
                <ActionButton
                  onPress={handleLogout}
                  UNSAFE_style={{
                    paddingTop: "4px",
                    height: "30px",
                    width: "50px",
                    fill: "white",
                    border: "none",
                    background: "none",
                    backgroundColor: "#071d49",
                    boxShadow: "none",
                  }}
                >
                  {showLogout && <LogOut />}
                </ActionButton>
                {showLogout && <Tooltip>Logout</Tooltip>}
              </TooltipTrigger>
            </Provider>
          </Flex>
        </Flex>
        {isDialogOpen && (
          <Dialog
            onDismiss={handleDialogClose}
            UNSAFE_style={{
              position: "fixed",
              right: "15px",
              top: "73px",
              width: "250px",
              height: "350px",
              backgroundColor: "#071d49",
            }}
          >
            <Heading>Notifications</Heading>
            <Content>
              <p>Your notifications will appear here.</p>
              <Button variant="secondary" onPress={handleDialogClose}>
                Close
              </Button>
            </Content>
          </Dialog>
        )}
      </header>
      {/* <Image
            UNSAFE_className="img"
            style={{ width: "10px", height: "10px", display: "flex" }}
            src={dssLogo}
            alt="Nextrow Logo"
            // height="size-800"
          /> */}
    </>
  );
};

export default Header;
